<div class="modal-header">
  <h4 class="modal-title"><i class="fa fa-upload"></i> Upload LCD Policy Document</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="upload-form">
    <!-- File Name Input -->
    <div class="form-group">
      <label for="fileName"><i class="fa fa-file-text-o"></i> File Name <span class="required">*</span></label>
      <input
        id="fileName"
        type="text"
        class="form-control input-nice"
        [(ngModel)]="fileName"
        placeholder="Enter an appropriate file name"
        maxlength="150"
        [disabled]="isSubmitting"
      />
    </div>

    <!-- Description (Optional) -->
    <div class="form-group">
      <label for="description"><i class="fa fa-align-left"></i> Description <small>(optional)</small></label>
      <textarea
        id="description"
        class="form-control input-nice"
        rows="3"
        [(ngModel)]="description"
        placeholder="Enter a short description (optional)"
        [disabled]="isSubmitting"
      ></textarea>
    </div>

    <!-- Payer Dropdown -->
    <div class="form-group">
      <label for="payer"><i class="fa fa-building"></i> Payer <span class="required">*</span></label>
      <select id="payer" class="form-control input-nice" [(ngModel)]="selectedPayer" [disabled]="isSubmitting">
        <option value="" disabled selected>Select a payer</option>
        <option *ngFor="let payer of payers" [value]="payer">{{ payer }}</option>
      </select>
    </div>

    <!-- File Upload -->
    <div class="form-group">
      <label><i class="fa fa-file-pdf-o"></i> LCD Policy Document (PDF) <span class="required">*</span></label>
      <div class="file-upload-area" (click)="browseFiles()">
        <input type="file" #fileInput (change)="onFileSelected($event)" accept="application/pdf" hidden [disabled]="isSubmitting" />
        <div *ngIf="!selectedFile" class="upload-placeholder">
          <i class="fa fa-upload"></i>
          <p>Click to browse and select a PDF file</p>
          <small>Only PDF files are accepted</small>
        </div>
        <div *ngIf="selectedFile" class="file-selected">
          <div class="file-info">
            <i class="fa fa-file-pdf-o file-icon"></i>
            <div class="file-details">
              <span class="file-name">{{ selectedFile.name }}</span>
              <span class="file-size">{{ (selectedFile.size / 1024 / 1024).toFixed(2) }} MB</span>
            </div>
          </div>
          <button type="button" class="btn btn-sm btn-danger" (click)="removeFile()" [disabled]="isSubmitting">
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="info-message">
      <i class="fa fa-info-circle"></i>
      <span>This document will be processed and stored for LCD coverage analysis.</span>
      <div *ngIf="isProcessing" class="d-flex flex-column align-items-center">
        <label class="mb-1 d-flex align-items-center justify-content-center">
          <strong>Processing Files</strong>
          <span class="ml-2"><i class="fa fa-spinner fa-spin"></i></span>
        </label>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-secondary" (click)="activeModal.dismiss()" [disabled]="isSubmitting">Cancel</button>
  <button class="btn btn-primary" (click)="submit()" [disabled]="isSubmitting">
    <i class="fa" [ngClass]="{ 'fa-spinner fa-spin': isSubmitting, 'fa-paper-plane': !isSubmitting }"></i>
    <span class="ml-1">Submit</span>
  </button>
</div>
